<template>
  <va-action-button
    v-if="hasAction('delete')"
    :hide-label="icon"
    :label="$t('va.actions.delete')"
    icon="mdi-trash-can"
    :color="color || 'red'"
    text
    @click="onDelete"
  ></va-action-button>
</template>

<script>
/* eslint-disable @typescript-eslint/dot-notation */
/**
 * Button for all delete resource action. Comes with confirm dialog.
 * Auto hide if no delete action available unless show prop is active.
 */
export default {
  name: 'CustomDeleteButton',
  props: {
    /**
     * Name of the resource to use.
     * Required for good label localization and context action activators.
     * Default behavior is to fetch it from router context.
     */
    resource: {
      type: String,
      default() {
        return this.$route.meta.resource;
      },
    },
    /**
     * Redirect to resource list after successful deletion.
     * Default redirect active if current page is resource being deleted.
     */
    redirect: { type: Boolean, default: false },
    /**
     * Item attached to the button.
     */
    item: { type: {}, default: () => null },
    /**
     * If true, show button with icon only, label will be shown as tooltip.
     */
    icon: Boolean,
    /**
     * Customizable background or text color, dependably of text prop value.
     */
    color: { type: String, default: 'red' },
  },
  computed: {
    translatable() {
      return this.$route.meta.translatable;
    },
    currentResource() {
      return this.$admin.getResource(this.resource);
    },
  },
  methods: {
    onClick() {
      /**
       * Triggered on click, send related item if available.
       */
      this.$emit('click', this.item);
    },
    async onDelete() {
      if (!this.item) {
        /**
         * Custom delete action if no item.
         * Used for bulk delete button which has his custom logic.
         */
        this.$emit('delete');
        return;
      }

      if (
        await this.$admin.confirm(
          this.$t('va.confirm.delete_title', {
            resource: this.currentResource.singularName.toLowerCase(),
            id: this.item['_id'],
          }),
          this.$t('va.confirm.delete_message', {
            resource: this.currentResource.singularName.toLowerCase(),
            id: this.item['_id'],
          }),
        )
      ) {
        await this.$store.dispatch(`${this.resource}/delete`, {
          id: this.item['_id'],
        });

        if (this.redirect) {
          this.$router.push({ name: `${this.resource}_list` });
          return;
        }

        this.$store.dispatch('api/refresh', this.resource);

        /**
         * Triggered on successful deletion of resource item.
         */
        this.$emit('deleted');
      }
    },
    hasAction(action) {
      /**
       * Check if access with user permissions for this specific action
       */
      return this.currentResource.canAction(action);
    },
    hasRoute(route) {
      /**
       * Check if CRUD route is defined for this resource
       */
      return !this.currentResource.routes || this.currentResource.routes.includes(route);
    },
  },
};
</script>
